<template>
  <el-card shadow="never" class="aui-card--fill">
    <div class="mod-trade__sell}">
      <el-form
          :inline="true"
          :model="dataForm"
          @keyup.enter.native="getDataList()"
      >
        <el-form-item label="统计时间：">
          <el-input v-model="dataForm.beginDate" :readonly="true"></el-input>
        </el-form-item>
        <el-form-item>
          <el-input v-model="dataForm.endDate" :readonly="true"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button @click="changeMonth(-1)" type="primary">上一月</el-button>
        </el-form-item>
        <el-form-item>
          <el-button @click="currentMonth()" type="primary">本月</el-button>
        </el-form-item>
        <el-form-item>
          <el-button @click="changeMonth(1)" type="primary">下一月</el-button>
        </el-form-item>
        <el-form-item>
          <el-button @click="refresh()">{{ $t('query') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="warning" @click="create()">生成报表</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="danger" @click="showImportDialog()"
          >上传零售数据
          </el-button
          >
        </el-form-item>
      </el-form>
      <el-tabs v-model="currentTab" type="card" >
        <el-tab-pane label="销售统计" name="1" :lazy="true">
          <sell-report :params="dataForm" ref="sellReport"></sell-report>
        </el-tab-pane>
        <el-tab-pane label="费用统计" name="2" :lazy="true">
          <cost-report :params="dataForm" ref="costReport"></cost-report>
        </el-tab-pane>
      </el-tabs>

    </div>
    <import-dialog ref="importDialog"></import-dialog>
  </el-card>
</template>

<script>
import moment from 'moment'
import importDialog from './import-dialog.vue'
import SellReport from '@/views/modules/sell/sell-report'
import CostReport from '@/views/modules/sell/cost-report'
export default {
  components: { importDialog,SellReport,CostReport },
  data () {
    return {
      currentTab:'1',
      dataForm: {
        beginDate: '',
        endDate: '',
      },
    }
  },

  mounted () {
    this.currentMonth()
  },
  methods: {
    refresh(){
      if(this.$refs.costReport){
        this.$refs.costReport.refresh()
      }
      if(this.$refs.sellReport){
        this.$refs.sellReport.refresh()
      }
    },
    changeMonth (month) {
      let b = moment(this.dataForm.beginDate)
      b.add(month, 'month')
      this.dataForm.beginDate = b.startOf('month').format('yyyy-MM-DD')
      this.dataForm.endDate = b.endOf('month').format('yyyy-MM-DD')
    },
    currentMonth () {
      let n = moment()
      this.dataForm.beginDate = n.startOf('month').format('yyyy-MM-DD')
      this.dataForm.endDate = n.endOf('month').format('yyyy-MM-DD')
    },
    create () {
      this.$http.post(`/trade/sell/create`, this.dataForm).then((res) => {
        this.refresh()
      })
    },
    showImportDialog () {
      this.$refs.importDialog.init()
    },
  },
}
</script>
